import { render, staticRenderFns } from "./DetalhamentoEstoque.vue?vue&type=template&id=8c1659e0&scoped=true"
import script from "./DetalhamentoEstoque.vue?vue&type=script&lang=js"
export * from "./DetalhamentoEstoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1659e0",
  null
  
)

export default component.exports